import type {Components, Theme} from '@mui/material/styles';
import {alertOverrides} from './alert/alert';
import {appBarOverrides} from './app-bar/app-bar';
import {buttonOverrides} from './button/button';
import {checkboxOverrides} from './checkbox/checkbox';
import {chipOverrides} from './chip/chip';
import {dataGridOverrides} from './data-grid/data-grid';
import {drawerOverrides} from './drawer/drawer';
import {dialogContentTextOverrides, dialogOverrides} from './dialog/dialog';
import {fabOverrides} from './fab/fab';
import {inputOverrides} from './input/input';
import {listItemTextOverrides, listOverrides} from './list/list';
import {menuOverrides} from './menu/menu';
import {paperOverrides} from './paper/paper';
import {radioOverrides} from './radio/radio';
import {selectOverrides} from './select/select';
import {switchOverrides} from './switch/switch';
import {tooltipOverrides} from './tooltip/tooltip';
import {skeletonOverrides} from './skeleton/skeleton';

export const componentOverrides: Components<Theme> = {
    MuiAlert: alertOverrides,
    MuiAppBar: appBarOverrides,
    MuiButton: buttonOverrides,
    MuiCheckbox: checkboxOverrides,
    MuiChip: chipOverrides,
    MuiDataGrid: dataGridOverrides,
    MuiDialog: dialogOverrides,
    MuiDrawer: drawerOverrides,
    MuiDialogContentText: dialogContentTextOverrides,
    MuiFab: fabOverrides,
    MuiInput: inputOverrides,
    MuiRadio: radioOverrides,
    MuiSelect: selectOverrides,
    MuiSwitch: switchOverrides,
    MuiListItemText: listItemTextOverrides,
    MuiList: listOverrides,
    MuiMenu: menuOverrides,
    MuiPaper: paperOverrides,
    MuiTooltip: tooltipOverrides,
    MuiSkeleton: skeletonOverrides,
};
